import { TEditorLayout } from '../../utils/editorLayout/editorLayout.types';

/**
 * Восстановление сохранённой конфигурации экрана. Экшен пересекает три слайса
 * (editor, general, contentWindows), поэтому живёт отдельным модулем: положи его
 * в editor — и general с contentWindows начали бы зависеть от editor без причины.
 *
 * Модуль намеренно без редьюсера: каждый слайс обрабатывает экшен у себя.
 */
export const LAYOUT_RESTORE = 'LAYOUT_RESTORE';

export interface ILayoutRestoreAction {
  layout: TEditorLayout;
}
